import { Link } from 'react-router-dom';
import CampusHeader from '../../components/feature/CampusHeader';
import Footer from '../../components/feature/Footer';

const HostelsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <CampusHeader />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 px-6 py-14 md:px-12 md:py-20 text-center shadow-sm">
          <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-teal-500/20 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-12 left-16 h-32 w-32 rounded-full bg-emerald-400/10 blur-2xl"></div>

          <div className="relative">
            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10 ring-1 ring-white/15 backdrop-blur-sm">
              <i className="ri-hotel-line text-3xl text-teal-300"></i>
            </div>

            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-teal-200 ring-1 ring-white/15">
              <i className="ri-time-line"></i>
              Coming Soon
            </span>

            <h1 className="mt-4 text-3xl md:text-4xl font-bold text-white">Hostels &amp; Housing</h1>
            <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-gray-300">
              We're building a dedicated space to find verified hostels and campus housing near your
              school — filter by university, area, and budget. It's launching soon.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/marketplace"
                className="inline-flex items-center rounded-lg bg-teal-600 px-6 py-3 font-semibold text-white transition-colors hover:bg-teal-700"
              >
                Browse the Marketplace
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/"
                className="inline-flex items-center rounded-lg bg-white/10 px-6 py-3 font-semibold text-white ring-1 ring-white/15 backdrop-blur-sm transition-colors hover:bg-white/20"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>

        <p className="mt-6 text-center text-sm text-gray-500">
          Are you a hostel or house agent?{' '}
          <Link to="/seller-dashboard" className="font-medium text-teal-600 hover:text-teal-700">
            Register your interest
          </Link>{' '}
          and be first to list when we launch.
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default HostelsPage;
